export { default } from './StarSmall'
